import { useState } from 'react';
import SHRMButton from '../../../../../../common/components/SHRMButton';
import certificate from './assets/membershipcertificate.gif';
import styles from './MembershipCertModal.module.css';

type CertificateModalProps = {
  isModalOpen: boolean;
  membership: any;
  closeModal: (e) => any;
  printCertificate: (isCard: boolean, isLetterSize: boolean) => any;
};

const MembershipCertificateModal = (props: CertificateModalProps) => {
  const [size, setSize] = useState('letter');

  const handlePrint = () => {
    props.printCertificate(false, size === 'letter');
  };

  const onOptionChange = e => {
    setSize(e.target.value);
  };

  return (
    <div>
      {props.isModalOpen && (
        <div className={styles.container} onClick={props.closeModal}>
          <div
            className={styles.content}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div className={styles.header}>
              <label className={styles.title}>SHRM CERTIFICATE OF MEMBERSHIP</label>
              <button className={styles.closeModalButton} onClick={props.closeModal}>
                ×
              </button>
            </div>

            <div className={styles.text}>
              To create your SHRM Certificate of Membership, please review your membership details
              listed below, once verified you may then print the PDF version of your certificate.
              <p>
                If you need to update your current member profile, please visit
                <span className={styles.linkBlue}> shrm.org/my/account</span>. If you need to change
                your Last Name specifically, please contact us at 800.283.7476, option 3 (U.S. only)
                or +1.703.548.3440 (International), option 3.
              </p>
            </div>
            <div className={styles.certificateSize}>
              <span>Certificate size:</span>
              <div className={styles.radio}>
                <input
                  name='size'
                  type='radio'
                  value='letter'
                  id='8.5 x 11'
                  defaultChecked
                  onClick={onOptionChange}
                />
                <label htmlFor='8.5 x 11'>8.5 x 11</label>
                <input name='size' type='radio' value='A4' id='A4' onClick={onOptionChange} />
                <label htmlFor='A4'>A4</label>
              </div>
            </div>
            <SHRMButton className={styles.generateCertificateButton} onClick={handlePrint}>
              generate membership certificate
            </SHRMButton>

            <div className={styles.previewLabel}>preview</div>

            <div className={styles.certificate}>
              <img src={certificate} />
              <span className={styles.name}>{props.membership.memberNameCredentials}</span>
              <span className={styles.date}>{props.membership.memberThrough}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MembershipCertificateModal;
